import { FC } from "react";

import { AttentionBanner, Icon } from "../../common";
import { KycModal } from "../../modals";

type Props = {
  show: boolean;
  setShow: (show: boolean) => void;
};

export const GetVerifiedBanner: FC<Props> = ({ show, setShow }) => {
  return (
    <div className="w-[340px] h-[244px]">
      <AttentionBanner
        heading={
          <div className="flex items-center gap-4">
            <Icon icon="KYC" size={24} />
            Get verified
          </div>
        }
        action={{
          label: "Verify",
          onClick: () => setShow(true),
        }}
      >
        To send invoices and receive payments. It will take a couple minutes
      </AttentionBanner>

      {show && <KycModal isOpen={show} close={() => setShow(false)} />}
    </div>
  );
};
